import * as types from '../mutations'

const state = {
    shopLis : [],
    selectedShop:{},
    user:1
}

const mutations = {
    GET_SHOP(state,shopLis){
        state.shopLis = shopLis
    },
    mUser(state,data){
        state.user = data
    }
}
const getters = {
    shopLis(state){
        return state.shopLis
    }
}
const actions = {
    getShop({commit},shopLis){
        commit(types.GET_SHOP,shopLis)
    },
    mUser(context,data){
        context.commit('mUser',data);
    }
}

export default{
    state,
    mutations,
    actions,
    getters
}




// WEBPACK FOOTER //
// ./src/store/modules/selectShop.js